import FormStatusBadge from 'components/badge/FormStatusBadge';
import { DivConst } from 'constants/divConst';

import type { FormResponseType } from 'types/api/formResponseType';
import { formatTimeToDate } from 'utils/app';
import { handleScrollToPopupEmbed } from 'utils/content';
import {
  formatPublishTerm,
  getLineProductionUrl,
  getProductionUrl,
  openLineProductionUrl,
  openProductionUrl,
} from 'utils/form';

import type { JSX } from 'react';

/**
 * フォーム作成編集 フォーム状態表示コンポーネント
 */
export default function WsFormEditStatusInfo(props: { form: FormResponseType }): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * 公開情報の表示可否を返します。
   */
  const _isVisiblePublishInfo = (): boolean => {
    // 掲載(予約)ステータスの場合は表示
    if (props.form?.formStatusDiv === DivConst.items.formStatus.reserved.value) {
      return true;
    }
    // 一度でも掲載を迎えたフォームの場合は表示
    if (props.form?.publishedAt != null) {
      return true;
    }
  };

  /**
   * ポップアップ埋め込みタグの表示可否を返します。
   * WsContentEditPopupEmbed.tsx の埋め込みタグ表示条件と一致させます。
   */
  const _isVisiblePopupEmbed = (): boolean => {
    if (!props.form?.popupImageKey) {
      return false;
    }
    return _isVisiblePublishInfo();
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {props.form && (
        <div className="section-header user-detail">
          <div className="card-detail">
            {props.form.lineFlag ? (
              <>
                <ul className="list-unstyled list-inline">
                  <li className="list-inline-item">
                    <b>フォーム作成日</b>：{formatTimeToDate(props.form.createdAt, 'yyyy/MM/dd')}
                  </li>
                  <li className="list-inline-item">
                    <FormStatusBadge formStatusDiv={props.form?.formStatusDiv} />
                  </li>
                  {_isVisiblePublishInfo() && (
                    <>
                      <li className="list-inline-item">
                        <b>公開期間</b>：
                        {formatPublishTerm({
                          formStatusDiv: props.form.formStatusDiv,
                          publishStartAt: props.form.publishStartAt,
                          publishEndAt: props.form.publishEndAt,
                          publishedAt: props.form.publishedAt,
                          terminatedAt: props.form.terminatedAt,
                        })}
                      </li>
                      <li className="list-inline-item">
                        <b>検索エンジン</b>：
                        <a>
                          {props.form.noIndexFlag && (
                            <span className="text-danger">インデックス対象外</span>
                          )}
                          {!props.form.noIndexFlag && <span>インデックス対象</span>}
                        </a>
                      </li>
                    </>
                  )}
                </ul>
                {_isVisiblePublishInfo() && (
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <b>公開URL</b>：
                      {props.form.formStatusDiv === DivConst.items.formStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => openLineProductionUrl(props.form.lineCd)}
                        >
                          {getLineProductionUrl(props.form.lineCd)}
                        </a>
                      )}
                      {props.form.formStatusDiv != DivConst.items.formStatus.published.value && (
                        <span> {getLineProductionUrl(props.form.lineCd)}</span>
                      )}
                    </li>
                    <li className="list-inline-item">
                      <b>LINE友だち追加後のURL</b>：
                      {props.form.formStatusDiv === DivConst.items.formStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => openProductionUrl(props.form.cd)}
                        >
                          {getProductionUrl(props.form.cd)}
                        </a>
                      )}
                      {props.form.formStatusDiv != DivConst.items.formStatus.published.value && (
                        <span> {getProductionUrl(props.form.cd)}</span>
                      )}
                    </li>
                  </ul>
                )}
                {_isVisiblePopupEmbed() && (
                  <ul className="list-unstyled list-inline mt-2">
                    <li className="list-inline-item">
                      <a href="#popup-embed" onClick={handleScrollToPopupEmbed}>
                        ポップアップ埋め込みタグ
                      </a>
                    </li>
                  </ul>
                )}
              </>
            ) : (
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">
                  <b>フォーム作成日</b>：{formatTimeToDate(props.form.createdAt, 'yyyy/MM/dd')}
                </li>
                <li className="list-inline-item">
                  <FormStatusBadge formStatusDiv={props.form?.formStatusDiv} />
                </li>
                {_isVisiblePublishInfo() && (
                  <>
                    <li className="list-inline-item">
                      <b>公開期間</b>：
                      {formatPublishTerm({
                        formStatusDiv: props.form.formStatusDiv,
                        publishStartAt: props.form.publishStartAt,
                        publishEndAt: props.form.publishEndAt,
                        publishedAt: props.form.publishedAt,
                        terminatedAt: props.form.terminatedAt,
                      })}
                    </li>
                    <li className="list-inline-item">
                      <b>検索エンジン</b>：
                      <a>
                        {props.form.noIndexFlag && (
                          <span className="text-danger">インデックス対象外</span>
                        )}
                        {!props.form.noIndexFlag && <span>インデックス対象</span>}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <b>公開URL</b>：
                      {props.form.formStatusDiv === DivConst.items.formStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => openProductionUrl(props.form.cd)}
                        >
                          {getProductionUrl(props.form.cd)}
                        </a>
                      )}
                      {props.form.formStatusDiv != DivConst.items.formStatus.published.value && (
                        <span> {getProductionUrl(props.form.cd)}</span>
                      )}
                    </li>
                  </>
                )}
                {_isVisiblePopupEmbed() && (
                  <ul className="list-unstyled list-inline mt-2">
                    <li className="list-inline-item">
                      <a href="#popup-embed" onClick={handleScrollToPopupEmbed}>
                        ポップアップ埋め込みタグ
                      </a>
                    </li>
                  </ul>
                )}
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
}
